export default function AdminHelp() {
  const sections = [
    {
      title: "Genel Bilgi",
      items: [
        "Dashboard kartları son 24 saati gösterir. Daha detaylı veriye ihtiyaç duyarsanız ilgili 'istatistik' API uçlarını kullanabilirsiniz.",
        "Zenitoon Admin sadece yetkili roller için açılır. Erişim sıkıntısı yaşayan kullanıcıya 'Dashboard.View' izni verildiğinden emin olun.",
      ],
    },
    {
      title: "Moderasyon",
      items: [
        "Toplu yorum işlemleri için önce filtre uygulayın, ardından listeden seçim yaparak gizle/göster/sil butonlarını kullanın.",
        "Her moderasyon aksiyonu log ekranına düşer. Gerekçe girerseniz kullanıcıya gönderilen bildirimde görünür.",
      ],
    },
    {
      title: "Rol / İzin",
      items: [
        "Mevcut bir rolü klonlayarak hızlıca yeni bir izin seti oluşturabilirsiniz. Klonlanan rolleri kullanıcıya atamayı unutmayın.",
        "İzin ekranında gruplar halinde gösterilen kodlar backend'deki permission catalogue ile birebirdir.",
      ],
    },
    {
      title: "Loglar",
      items: [
        "Log ekranındaki filtreler alan/adım, kullanıcı veya zaman aralığına göre daraltmanıza izin verir.",
        "Kritik (Severity=2) loglar kırmızı olarak işaretlenir. 'İncele' butonuyla metadata'yı kopyalayabilirsiniz.",
      ],
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">Yönetim Yardım &amp; Rehber</h1>
        <p className="text-sm text-slate-500">
          Bu sayfa sık karşılaşılan sorular ve operasyon ipuçlarını kısa notlar halinde sunar. Ek gereksinimler için teknik ekiple
          iletişime geçebilirsiniz.
        </p>
      </div>

      {sections.map((section) => (
        <section key={section.title} className="rounded bg-white p-4 shadow">
          <h2 className="text-lg font-semibold text-slate-800">{section.title}</h2>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            {section.items.map((item, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-brand-600">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
